(() => {
  const isTouchable = "ontouchstart" in window || (window.DocumentTouch && document instanceof DocumentTouch);
  const touchStartEvent = isTouchable ? "touchstart" : "click";
  const touchEndEvent = isTouchable ? "touchend" : "click";

  /**
   * スマホナビゲーションの操作
   */
  function navigation() {
    const body = document.getElementsByTagName("body")[0];
    const spNav = document.querySelector(".js-spnav");
    const navDrawer = spNav.querySelector(".js-drawer");
    const toggleBtn = spNav.querySelector(".js-menuToggle");
    const menuLinks = navDrawer.querySelectorAll(".menu > .menu-item > a");

    // sp menuの開閉
    toggleBtn.addEventListener(touchStartEvent, () => {
      if (toggleBtn.getAttribute("aria-expanded") === "true") {
        toggleBtn.setAttribute("aria-expanded", "false");
        delete body.dataset.navState;
        navDrawer.classList.remove("toggled");
      } else {
        toggleBtn.setAttribute("aria-expanded", "true");
        body.dataset.navState = "open";
        navDrawer.classList.add("toggled");
      }
    });

    // メニューリンククリックでナビ閉じる
    // menuLinks.forEach((menuLink) => {
    //   menuLink.addEventListener(touchEndEvent, () => {
    //     toggleBtn.setAttribute("aria-expanded", "false");
    //     delete body.dataset.navState;
    //     navDrawer.classList.remove("toggled");
    //   });
    // });
        menuLinks.forEach((menuLink) => {
          menuLink.addEventListener("click", () => {
            toggleBtn.setAttribute("aria-expanded", "false");
            delete body.dataset.navState;
            navDrawer.classList.remove("toggled");
          });
        });
  }

  function toPageTop() {
    const toTopBtn = document.querySelector(".js-totop");
    toTopBtn.addEventListener(touchStartEvent, (event) => {
      event.preventDefault();
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    });
  }

  window.addEventListener("DOMContentLoaded", () => {
    navigation();
    toPageTop();
  });

  window.addEventListener("load", () => {
    document.getElementsByTagName("body")[0].dataset.loading = "loaded";
  });
})();
